export function executeBotTurn(gameState, isHandLocked, playableCards) {
    const activePlayer = gameState.getCurrentPlayer();

    if (isHandLocked) {
        console.log("Bot is locked! Discarding a random card...");

        // Pick a random card from the hand
        const randomCardIndex = Math.floor(Math.random() * activePlayer.hand.length);

        return { discard: true, cardIndex: randomCardIndex };

    } else {
        // Pick a random playable card
        const randomPlayableCardIndex = Math.floor(Math.random() * playableCards.length);
        const cardIndexToPlay = playableCards[randomPlayableCardIndex];
        const card = activePlayer.hand[cardIndexToPlay];

        // Find which slots are valid targets for this specific card
        const validSlots = [];
        for (let i = 0; i < 6; i++) {
            if(card.isValidOn(i, gameState)) {
                validSlots.push(i);
            }
        }

        // Pick a random valid slot to aim at
        const targetSlotIndex = validSlots[Math.floor(Math.random() * validSlots.length)];

        console.log(`Bot selected ${card.typeId}. Aiming at slot ${targetSlotIndex}`);

        return { cardIndex: cardIndexToPlay, slotIndex: targetSlotIndex };
    }
}
